import { validators } from 'model-core';

const {
  stringValidator,
  nullableArrayValidator,
  nullableDateValidator,
  nullableStringValidator,
  booleanValidator,
} = validators;

export const CreditSchema = {
  type: 'object',
  $schema: 'http://json-schema.org/schema#',
  title: 'Credit',
  properties: {
    addressLine1: nullableStringValidator,
    addressLine2: nullableStringValidator,
    city: nullableStringValidator,
    state: nullableStringValidator,
    zipcode: nullableStringValidator,
    isEnrolled: booleanValidator,
    enrolledDate: nullableDateValidator,
    unenrolledDate: nullableDateValidator,
    reportingHistory: nullableArrayValidator,
    isIndividualPayment: booleanValidator,
    price: {
      type: ['number', 'null'],
    },
    nextPaymentDate: nullableDateValidator,
    paymentMethod: {
      type: ['object', 'null'],
      properties: {
        brand: nullableStringValidator,
        last4: nullableStringValidator,
      },
    },
  },
};

export const CreditPaymentSchema = {
  type: 'object',
  $schema: 'http://json-schema.org/schema#',
  title: 'CreditPayment',
  properties: {
    date: nullableStringValidator,
    amount: {
      type: ['number', 'null'],
    },
    status: nullableStringValidator,
  },
};

export const ReportingHistorySchema = {
  type: 'object',
  $schema: 'http://json-schema.org/schema#',
  title: 'ResidentHistory',
  properties: {
    date: stringValidator,
    status: stringValidator,
  },
};

export const ResidentCreditSchema = {
  type: 'object',
  $schema: 'http://json-schema.org/schema#',
  title: 'ResidentCredit',
  properties: {
    firstName: stringValidator,
    emailMasked: nullableStringValidator,
    propertyName: stringValidator,
    offeringStatus: stringValidator,
    hasResidentBirthday: booleanValidator,
    isIndividualPayment: booleanValidator,
    price: {
      type: ['number', 'null'],
    },
    nextPaymentDate: nullableDateValidator,
    nextRentReportDate: nullableDateValidator,
  },
};
